@if (safeContentUrl || inlineHtml) {
  <iframe
    #contentFrame
    class="h-full min-h-[330px] w-full bg-white"
    title="Visualizador de conteúdo HTML/WebGL"
    loading="lazy"
  ></iframe>
} @else {
  <div class="grid h-full min-h-[330px] place-items-center px-6 text-center text-lWhite/75">
    <p>Conteúdo HTML/WebGL indisponível para esta aula.</p>
  </div>
}
